module.exports = __webpack_public_path__ + "img/1.177b3bd3.png";